import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import type { FinancialMovement } from '@/types';

export function useFinancialMovements() {
  const [movements, setMovements] = useState<FinancialMovement[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: queryError } = await supabase
        .from('financial_movements')
        .select('*')
        .order('movement_date', { ascending: false })
        .order('created_at', { ascending: false });
      if (queryError) throw queryError;
      setMovements((data as FinancialMovement[]) || []);
    } catch {
      setMovements([]);
      setError('No fue posible cargar los movimientos. Verifique su conexión e intente nuevamente.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { movements, loading, error, reload: load };
}